import Assert from '@/helpers/assert';
import uniq from 'lodash/uniq';

const assignRolesToUserById = (soulApiRequest) => async (user, roles) => {
  Assert.isPresent(user, 'user');
  Assert.isPresent(user.id, 'user.id');

  Assert.isArray(user.roles, 'user.roles');
  Assert.isArray(roles, 'roles');

  const { id, roles: currentRoles } = user;
  const updatedRoles = uniq(currentRoles.concat(roles));

  const response = await soulApiRequest({
    url: `/user/${encodeURIComponent(id)}`,
    method: 'patch',
    data: {
      roles: updatedRoles
    }
  });

  return response.data;
};

export default assignRolesToUserById;
